import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconedButton from '../../../shared/iconed-button';
import FundFollowButton from '../fund-follow-button';
import EnquiryContext from '../../../shared/enquiry/context';
import { recordStatisticsEvent } from '../../../../services/statistics-service';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;

  ${props => props.theme.isXLarge && `
    padding-top: 32px;
  `};

  ${props => props.theme.isMobile && `
    padding-top: 10px;
  `};

  width: ${props => (props.theme.isLarge ? 132 : 107)}px;

  & button > span:not(.icon-lw) {
    font-size: ${props => (props.theme.isLarge ? 14 : 12)}px;
  }

  && > button[name="fund-follow-button"] {
    width: 100%;
    margin-top: 0;
    ${props => props.theme.isMobile && `
      height: 33px;
    `};
    ${props => !props.theme.isLarge && `
      > .icon-box > .icon-lw-user-check {
        left: 0px;
      }
    `};
  }

  &&&& button:not([name="fund-follow-button"]) {
    width: 100%;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
  }

`;

const DarkButton = styled(IconedButton)`
  outline: none;
  margin-top: 12px;
  width: 100%;
  height: 36px;
  background-color: #3C4966;

  ${props => props.theme.isMobileOrTablet && `
    width: 120px;
    margin-top: 8px;
    align-items: center;
    justify-content: center;
  `};

  ${props => props.theme.isMobile && `
    height: 33px;
    & > span:not(.icon-lw) {
        font-size: 14px;
    }
  `};

  &:hover {
    background-color: #414651;
    color: ${props => props.theme.bodyBackgroundColor};
  }

  & > span.icon-lw {
    font-size: 16px;
    padding: 5px;
    background-color: ${props => props.theme.bodyColor};
  }
`;

export default function Actions({ fund, showInModal, showContactButton }) {
  const { dispatch } = React.useContext(EnquiryContext);

  const handleContactClick = e => {
    e && e.preventDefault();

    recordStatisticsEvent({
      event: 'fund_profile_top_section_contact_clicked',
      statisticable: 'fund',
      id: fund.id,
      page: window.location.pathname,
    });

    if (_.get(window, 'Livewire.currentUser.id')) {
      dispatch({ type: 'showEnquiryForm', payload: { scroll: !showInModal } });
      if (showInModal) {
        const el = document.getElementsByName('contact')[0];
        el && el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location = '/sign_up?return_to_section=enquiry';
    }
  };

  const onMount = () => {
    if (window.location.hash === '#enquiry') {
      dispatch({ type: 'showEnquiryForm', payload: { scroll: true } });
    }
  };

  return (
    <Container ref={onMount}>
      <FundFollowButton fund={fund} lessUnfollow />
      {!!showContactButton && (
        <DarkButton type="button" className="btn" onClick={handleContactClick}>
          <span className="icon-lw icon-lw-contact" />
          <span>Contact</span>
        </DarkButton>
      )}
    </Container>
  );
}

Actions.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    isFollowedByCurrentUser: PropTypes.bool,
  }).isRequired,
  showContactButton: PropTypes.bool.isRequired,
  showInModal: PropTypes.bool.isRequired,
};
